import { MutationTree } from 'vuex'
import { MapState } from './types'
declare const google: any

export const mutations: MutationTree<MapState> = {
  initMapState(state, payload: MapState) {
    state.zones = payload.zones
  },
  setMap(state,payload){
    state.map = payload
  },
  currentGeofence(state,payload){
    state.currentZone = payload
  },
  currentPoint(state,payload){
    state.currentZone = payload
  }
}
